import { render, staticRenderFns } from "./SelectIdioma.vue?vue&type=template&id=fff626ca"
import script from "./SelectIdioma.vue?vue&type=script&lang=js"
export * from "./SelectIdioma.vue?vue&type=script&lang=js"
import style0 from "./SelectIdioma.vue?vue&type=style&index=0&id=fff626ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports